import { getFirstModuleOfArray } from "../routes/manageRouting";
import I18n from "../I18n";

export function selectObjectById(accounts, idToFound) {
    const accountFound = (accounts || []).find(({ id }) => +id === +idToFound);
    if (accountFound && accountFound.name !== "") {
        return accountFound;
    }
    return undefined;
}

export function mapProjectContext(
    project,
    projectId,
    organization,
    selectedYear,
    selectedYearType,
) {
    let projectObj = undefined;
    //check if navigate by fiscalYear
    if (project && project.fiscalYears && Object.keys(project.fiscalYears).length > 0) {
        const mostRecentFiscalYear = Math.max(...Object.keys(project.fiscalYears));
        const projectModules = project && project.modules;
        const findFirstModule = getFirstModuleOfArray(
            (projectModules || []).filter((r) => r.default_module === 0).map((elem) => elem.name),
        );
        const checkForOnlyRepo = (projectModules || []).some((elem) => elem.name === "archive");
        const moduleFound = (projectModules || []).find((elem) => elem.name === findFirstModule);
        //found an matched modules and not default (repository)
        let navigationImportID = "full";
        let moduleOrRouteToUse = "";
        const hasNewNavigation = (projectModules || []).some(({ name }) => name === "new_navigation")
        if (moduleFound && !checkForOnlyRepo) {
            if (!hasNewNavigation) {
                moduleOrRouteToUse = moduleFound.name;
            }
            if (moduleFound.navigation_by_import_id && moduleFound.navigation_by_import_id !== 2) {
                const filterFullImportId = project.fiscalYears[mostRecentFiscalYear]
                    .filter(({ id }) => id !== "full")
                    .map(({ id }) => id);
                if (filterFullImportId?.length) {
                    navigationImportID = Math.max(...filterFullImportId);
                }
            }

            if (!hasNewNavigation && moduleFound?.default_route?.length) {
                moduleOrRouteToUse = moduleFound.default_route;
            }

            projectObj =
                organization.organizationExpired === 0 &&
                    organization.organizationActive === 1 &&
                    project.projectExpired === 0 &&
                    project.active === 1
                    ? {
                        ...project,
                        to: `/${project.id}/${mostRecentFiscalYear}/${navigationImportID}/${moduleOrRouteToUse || "overview"}`,
                        isSelected: project.id === projectId,
                    }
                    : {
                        ...project,
                    };
        }
        if (projectObj) {
            projectObj[`organizationMaxFiscalYear`] = selectedYear ?? mostRecentFiscalYear;
            projectObj.selectedYear = selectedYear;
            projectObj.yearType = selectedYearType;
        }
    }

    if (!projectObj && organization) {
        projectObj =
            organization.organizationExpired === 0 &&
                organization.organizationActive === 1 &&
                project.projectExpired === 0 &&
                project.active === 1
                ? {
                    ...project,
                    to: `/${project.id}/repository/activity/status`,
                    isSelected: project.id === projectId,
                }
                : {
                    ...project,
                };
        projectObj.selectedYear = selectedYear;
        projectObj.yearType = selectedYearType;
    }

    return { ...projectObj, type: "project" };
}

const projectCardMapper = (project) => [
    [
        {
            labels: ["name"],
            value: project.name,
            align: "left",
        },
    ],
    [
        {
            labels: ["status"],
            value: {
                value:
                    project.projectExpired === 0
                        ? I18n.translate`In Progress`
                        : I18n.translate`Expired`,
                label:
                    project.projectExpired === 0
                        ? I18n.translate`In Progress`
                        : I18n.translate`Expired`,
                severity: 4,
                color: "main",
                family: project.projectExpired === 0 ? "success" : "error",
            },
            align: "left",
        },
    ],
    [{ labels: ["period"], value: project.period, align: "left" }],
    [
        {
            labels: ["active"],
            value: {
                value: project.active === 1 ? I18n.translate`Yes` : I18n.translate`No`,
                label: project.active === 1 ? I18n.translate`Yes` : I18n.translate`No`,
                severity: 4,
                color: "main",
                family: project.active === 1 ? "success" : "error",
            },
            align: "left",
        },
    ],
    [
        {
            labels: ["aggregationDataResult"],
            value: {
                customComponent: "HeatMapOrganizationProject",
                ...project,
            },
        },
    ],
];

export function mapProjectsByOrganization(
    organization,
    projectId,
    selectedYear,
    selectedYearType,
    organizationModules,
) {
    const tempProjects = (organization.projects || [])
        .sort(({ name: a }, { name: b }) => a.localeCompare(b))
        .map((project) => {
            const projectMapped = mapProjectContext(
                project,
                projectId,
                organization,
                selectedYear,
                selectedYearType,
            );
            const fiscalYearsString = Object.keys(projectMapped.fiscalYears).join(", ");

            return {
                ...projectMapped,
                card: projectCardMapper({
                    ...projectMapped,
                    name: `${projectMapped.taxRegistrationNumber} - ${projectMapped.name}`,
                    organizationModules,
                    period: fiscalYearsString,
                }),
            };
        });
    return tempProjects;
}
